import { ref } from 'vue';
import { isOldOrg } from '@/api/organization';
import { getOrgId } from '@/utils/tool';

const isNewSms = ref(false);

const useNewSms = () => {
  const determineNewSms = async (id?: string) => {
    const orgId = id || getOrgId();
    if (!orgId) return;
    try {
      const res = await isOldOrg(orgId);
      isNewSms.value = !res.data;
    } catch (error) {
      isNewSms.value = false;
    }
  };

  return {
    determineNewSms,
    isNewSms,
  };
};

export default useNewSms;
